import { useXpanseAuth } from '@/hooks/useXpanseAuthentication';
import { useBoolean } from 'minimal-shared/hooks';

import Box from '@mui/material/Box';

import { useSettingsContext } from '../context/use-settings-context';
import { useResponsive } from '../hooks/useResponsive';
import Header from './Header';
import Main from './Main';
import NavMini from './navigation/NavMini';
import NavVertical from './navigation/NavVertical';

export default function Layout({ children }: { children: React.ReactNode }) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  const { isEmbedded } = useXpanseAuth();

  const isMini = settings.state.navLayout === 'mini';

  const isNotEmbedded = !isEmbedded();

  const renderNavMini = <NavMini />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}

          <Main>{children}</Main>
        </Box>
      </>
    );
  }

  return (
    <>
      {isNotEmbedded && <Header onOpenNav={nav.onTrue} />}

      <Box
        className={isNotEmbedded ? '' : 'embedded-layout'}
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        {isNotEmbedded && renderNavVertical}
        <Main>{children}</Main>
      </Box>
    </>
  );
}
